import { post, put } from '../..';

type Payload = {
  ParentId: string,
  LocationId?: string,
  Floor: {
    Name: string,
    Number: string,
    Priority: boolean,
    Svg?: string,
    imageType?: string,
    imageName?: string,
    imageSize?: number,
    ExternalId?: string,
  }
}

const updateFloor = (
  Name: string,
  Number: string,
  Priority: boolean,
  Svg: string,
  imageType: string,
  imageName: string,
  imageSize: number,
  ParentId: string,
  LocationId?: string,
  ExternalId?: string,
) => {
  const endpoint: string = 'locations/floors';
  const body: Payload = {
    ParentId,
    LocationId: null,
    Floor: {
      Name, Number, Priority, Svg, imageType, imageName, imageSize,
    },
  };

  if (ExternalId?.length > 0 && typeof ExternalId === 'string') body.Floor.ExternalId = ExternalId;

  if (LocationId) {
    body.LocationId = LocationId;
    return put(endpoint, body);
  }
  return post(endpoint, body);
};

export default updateFloor;
